module.exports = __webpack_public_path__ + "media/images/icons/edit-fb5b8b5c0937eb6432bd73bd81816896.svg";